import { UploadedItem } from '@snsw/react-component-library';
import styled, { css } from 'styled-components/macro';
import { useEffect, useRef } from 'react';

interface Props {
  id: string;
  name: string;
  size: number;
  onRemove: (id: string) => void;
  disabled?: boolean;
}

const Container = styled.div<{ disabled: Props['disabled'] }>`
  ${(props) =>
    props.disabled
      ? css`
          cursor: not-allowed;
          button {
            pointer-events: none;
          }
        `
      : ''}
`;

export const UploadedFileItem = ({ id, name, size, onRemove, disabled }: Props) => {
  const containerRef = useRef<HTMLDivElement | undefined>();
  const handleRemove = () => onRemove(id);

  useEffect(() => {
    const { current: container } = containerRef;

    if (!container) {
      return;
    }

    const button = container.getElementsByTagName('button');
    if (button.length) {
      button[0].disabled = disabled;
    }
  }, [disabled]);

  return (
    <Container className="data-hj-suppress" ref={containerRef} disabled={disabled}>
      <UploadedItem key={id} id={id} name={name} size={size} onRemove={handleRemove} />
    </Container>
  );
};
